<template>
  <div class="ask_ai position-fixed w-100" style="z-index: 9;">
    <div v-if="showChatData" class="overlay_section" @click="hideAiwidget()"></div>
    <div class="assistant_card_strip">
      <transition name="bar-slide" @after-leave="showWindow = true">
        <div class="bg-white custom_box_shadow position-relative" v-if="showBar" style="z-index: 98">
          <div class="container">
            <div class="d-flex align-items-center row" @click="openchatwidget();">
              <div class="flex-1">
                <div class="d-flex align-items-center">
                  <AssistantIcon />
                  <div class="py-4 pl-3"
                    placeholder="How can we help you today? For example, can I get a price on a new Honda Accord?">
                    <p class="m-0 font-weight-bold strip_input">{{ stripInput }}
                    </p>
                  </div>
                </div>


              </div>
              <div>
                <div class="d-flex align-items-center gap-lg-1">
                  <div>
                    <MicrophoneIcon />
                  </div>
                  <div>
                    <!-- <span class="border_horizontal"></span> -->
                  </div>
                  <div>
                    <!-- <AssistantIcon /> -->
                    <div class="arrow_down cursor_pointer" :style="{ background: primarycolor, color: '#fff' }">
                      <em class="primaryicon-longarrow-right" />
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>
      </transition>
      <transition name="window-slide" @after-enter="showInput = true" @after-leave="showBar = true">
        <div v-if="showChatData && showWindow" class="expandable-content" :style="setBackgroudColor" :class="[
          designId == 1 ? 'classicDesign' :
            designId == 2 ? 'newClassicDesign' :
              'primeDesign container'
        ]">
          <div
            class="d-flex justify-content-end mt-2 bg-white custom_box_shadow rounded-circle position-absolute close_icon_container">
            <div class="primary-close-circle_icon cursor-pointer " @click="hideAiwidget()">
              <em class="primaryicon-times "></em>
            </div>
          </div>

          <div class="row flex-1 conversation_container" id="chat__bodyview">
            <div class="col-md-12">
              <div class="pt-5 px-lg-4">
                <div v-for="(item, index) in fullfillmenttextList" :key="index">
                  <UserQuestion v-if="item.request?.UserResponse" :userinput="item.request" :design="designId"
                    :requesttime="item.requestTime" :index="index" :initial-name="item.initials"
                    :chat-theme-settings="chatThemeSettings" />
                  <UserQuestion v-else-if="item.request?.EventLabel" :userinput="item.request" :design="designId"
                    :requesttime="item.requestTime" :index="index" :initial-name="item.initials"
                    :chat-theme-settings="chatThemeSettings" />


                  <ai-full-fill-ment-text v-if="item && item.responseData" :request="item.request" :item-data="item"
                    @tvm-suggestions="tvmSuggestions" @tvm-structured-suggestions="tvmSuggestions" :design="designId"
                    :user-input-text="userInput" :selected-auto-completed-value="selectedAutoCompletedValue"
                    @selectedInputAddress="selectedInputAddress" @selectedInputYmmt="selectedInputYmmt"
                    :response-data="item.responseData" :chat-theme-settings="chatThemeSettings"
                    :response-time="item.responseTime" :is-last-index="fullfillmenttextList.length
                      ? fullfillmenttextList.length - 1 === index
                      : false
                      " :full-fill-ment-text="item.fullfillmentText">
                  </ai-full-fill-ment-text>
                </div>

                <tvm-pre-loader v-if="chatResponseDelayLoading || isLoader" />


              </div>
            </div>
          </div>
          <transition name="input-slide">
            <div v-if="showInput">
              <div class="px-4 d-flex mx-lg-5 ">
                <div class="mt-4">
                  <AssistantWithSpark :height="65" :width="65" :is-gradient="isGradient" />
                </div>
                <div class="flex-1 ml-2">
                  <div class="d-flex align-items-center px-3 chat_input_container">
                    <div class="flex-1 pt-2">
                      <textarea rows="2" id="MessageContainer" @focus="clearPropmpts()"
                        :placeholder="disableText ? disableText : 'Type your message...'" autocomplete="off"
                        @keyup.enter="sendMessage()" v-model="userInput"
                        class="form-control shadow-none border-0 bg-transparent _theme_font_bold" type="text"
                        placeholder="How can we help you today? For example, can I get a price on a new Honda Accord?">
                    </textarea>
                    </div>
                    <div>
                      <div class="d-flex align-items-center  send_container">
                        <div class="cursor_pointer" @click="startSpeechToText()">
                          <!-- <MicroPhone color="#888" /> -->

                          <div class="pulse-container" :class="{ 'pulse': isListening }">
                            <MicrophoneIcon />
                          </div>
                        </div>
                        <div @click="sendMessage"
                          class="send_icon bgcolor-primary d-flex align-items-center justify-content-center cursor_pointer">
                          <em class="primaryicon-longarrow-right"></em>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="d-flex align-items-center gap-lg-1 mb-2">
                    <div class="d-flex align-items-center    rounded-buttons btn cursor-pointer footer_icon"
                      :style="{ background: isGradient ? 'rgba(255,255,255,0.1)' : '#eee' }" @click="
                        startMainMenu($event);">
                      <menu-icon :is-hover-menu="isHoverMenu" height="18px" width="20px" />
                      <span class="pl-1">Menu</span>
                    </div>
                    <div @click="showHoursModal()"
                      class="d-flex align-items-center  rounded-buttons btn cursor-pointer footer_icon"
                      :style="{ background: isGradient ? 'rgba(255,255,255,0.1)' : '#eee' }">
                      <hours-icon :is-hover-hour="isHoverHour" height="18px" width="20px" />
                      <span class="pl-1">Hours</span>
                    </div>

                    <div class="d-flex align-items-center    rounded-buttons btn  cursor-pointer footer_icon"
                      :style="{ background: isGradient ? 'rgba(255,255,255,0.1)' : '#eee' }"
                      v-if="enableTranslationIcon" @click="languageChangeEvent()">
                      <language-change-icon :icon-plus-text="true">
                        <template #iconPlusText="slotProps">
                          <div class="d-flex align-items-center">
                            <language-icon :is-hover-language="isHoverLanguage" height="18px" width="20px" />
                            <span ref="languageRefContent" class="m-0 pl-1">{{ slotProps.text }}</span>
                          </div>

                        </template>
                      </language-change-icon>
                    </div>
                    <div class="d-flex align-items-center   rounded-buttons btn cursor-pointer footer_icon"
                      :style="{ background: isGradient ? 'rgba(255,255,255,0.1)' : '#eee' }" v-if="!disableSignIn"
                      @click="LogoutUser($event)">
                      <sign-in-icon :is-hover-user="isHoverUser" height="18px" width="20px" />
                      <span class="pl-1"> {{ isAuthenticated === "True" ? "Sign Out" : "Sign In" }}</span>
                    </div>
                  </div>
                </div>
              </div>

            </div>

          </transition>



          <div v-if="showModal">
            <div id="viewDetailsModal" class="modal" :style="{ display: showModal ? 'block' : 'none' }">
              <div class="modal-dialog">
                <div class="modal-content">
                  <!-- Modal Header -->
                  <div class="modal-header align-items-center">
                    <h6 class="m-0 _theme_font_bold">Hours</h6>
                    <div>
                      <button type="button" aria-label="Close" class="close" @click.prevent="showModal = false">
                        ×
                      </button>
                    </div>
                  </div>
                  <div class="p-3">
                    <DealerWorkingHours />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-backdrop show" />
          </div>
          <tvm-loader-modal v-if="isSignInNavigationModal" message="Logging you in. Please wait..." />
          <tvm-loader-modal v-if="isSignOut" message="Logging you out. Please wait..." />
          <tvm-loader-modal v-if="isTranslationChange" message="Translating content. Please wait..." />

        </div>
      </transition>
    </div>
    <div v-if="showchat && !ismobile && !isChatOpenInModal" id="chat_button_enabled" class="d-none">
      <chat-assistant @openAssistant="openAssistant($event)" @openService="openService($event)"
        @tileNavigate="assistantParamsDataModal($event)" @modalNavigate="modalNavigate($event)"
        @disableWebBackgroundBlur="disableWebBackgroundBlur($event)"
        @assistantSettingsData="assistantSettingsData($event)" />
    </div>
  </div>

</template>

<script>
import UserQuestion from "./Aicomponents/UserQuestion.vue";
import { mapWritableState } from 'pinia';
// import { useConversationStore } from "../../store/AiConversationStore/AiConversationStore";
import AssistantIcon from "./icons/AssistantIcon.vue";
// import MicroPhone from "./icons/MicroPhone.vue";
import chatwidget from "../ChatWidget/ChatWidget.js";
import { ChatWidgetService } from "../../../Services/ChatWidgetService/ChatWidgetService.js";
import AiFullFillMentText from "./AiComponents/AiFullFillMentText.vue";
import TvmPreLoader from "../TvmPreLoader/TvmPreLoader.vue";
import { useChatSettingsStore } from '../../../store/ChatSettingsStore/ChatSettingsStore.js';
import AiHoursModal from "./AiComponents/AiHoursModal.vue";
import DealerWorkingHours from "../DealerWorkingHours/DealerWorkingHours.vue";
// import MicroPhone from "./icons/MicroPhone.vue";
import MicrophoneIcon from "../ChatIcons/MicrophoneIcon.vue";
import { getAiPrompts } from "./config/AiPrompts.js";
import { ref } from "vue";
import AssistantWithSpark from "./Icons/AssistantWithSpark.vue";
import eventBus from '../../../Services/EmitterService/EmitterService';
import { generateGradient } from "../../../../../js/services/CommonUtility.js";




export default {
  mixins: [chatwidget],
  data() {
    return {
      isExpanded: false,
      messageInput: '',
      sessionID: null,
      showModal: false,
      designId: null,
      isListening: false,
      recognition: null,
      showInput: false,
      showWindow: false,
      userInput: '',
      predefinedPrompt: 'How can we help you today?',
      typingIndex: 0,
      typingInterval: null,
      prompts: [],
      currentPromptIndex: 0,
      currentWordIndex: 0,
      words: [],
      inputRef: ref(null),
      stripTypingInterval: null,
      stripInput: '',
      isSpeaking: false,
      isGradient: false,
      primaryColor: window.primaryColor
    };
  },
  created() {
    this.sessionID = sessionStorage.getItem("sessionID") || this.generateSessionID();
    sessionStorage.setItem("sessionID", this.sessionID);
    let searchParams = new URLSearchParams(location.search);
    if (searchParams.get('gradient')) {
      this.isGradient = true;
      const storeThemeSettings = useChatSettingsStore();
      storeThemeSettings.chatThemeSettings = { ...this.chatThemeSettings, isGradient: true };
    } else {
      this.isGradient = false;
    }
  },
  computed: {
    ...mapWritableState(useChatSettingsStore, ['chatThemeSettings']),
    setBackgroudColor() {
      if (this.isGradient) {
        return { background: generateGradient(this.primaryColor) };
      } else {
        return { background: '#f9f9f9' };
      }
    }
  },
  methods: {
    toggleExpand() {
      this.isExpanded = !this.isExpanded;
      if (this.isExpanded) {
        this.openAssistant();
        let cookieId = ChatWidgetService.getChatSessionCookie();
        let oldsid = sessionStorage.getItem('oldsid');
        if (oldsid && cookieId && oldsid !== cookieId) {
          this.loadChatWithSessionData(cookieId, oldsid);
        } else {
          this.loadChatWithSessionData(cookieId, null);
        }
      } else {
        this.showChatData = false;
      }
    },
    // sendMessage() {
    //   if (this.messageInput.trim()) {
    //     try {
    //       const conversationStore = useConversationStore();
    //       let request = {
    //         UserResponse: this.messageInput,
    //       };
    //       conversationStore.sendMessage(request);
    //       console.log(conversationStore, 'conversationStore')
    //       this.messageInput = '';
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   }
    // },
    hideAiwidget() {
      this.showInput = false
      setTimeout(() => {
        this.showWindow = false;
        this.hidewidget();
      }, 300);
    },
    generateSessionID(length = 50) {
      const charset = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
      let sessionID = "";
      for (let i = 0; i < length; i++) {
        sessionID += charset.charAt(Math.floor(Math.random() * charset.length));
      }
      return sessionID;
    },
    showHoursModal() {
      this.showModal = true;
    },
    startSpeechToText() {
      this.userInput = '';
      this.isSpeaking = false;
      if (!('webkitSpeechRecognition' in window)) {
        alert('Speech recognition is not supported in this browser.');
        return;
      }

      if (this.recognition && this.isListening) {
        this.recognition.stop();
        this.isListening = false;
        this.isSpeaking = false;
        console.log('Speech recognition stopped.');
        return;
      }

      this.recognition = new webkitSpeechRecognition();
      this.recognition.lang = 'en-US';
      this.recognition.interimResults = false;
      this.recognition.maxAlternatives = 1;
      this.recognition.continuous = false;

      this.recognition.onstart = () => {
        this.isListening = true;
        this.isSpeaking = false;
        console.log('Speech recognition started...');
      };

      this.recognition.onresult = (event) => {
        const transcript = event.results[0][0].transcript;
        this.userInput = transcript;
        this.isSpeaking = false;
        this.isListening = false;
        console.log('Recognized text:', transcript);
        this.sendMessage();
      };

      this.recognition.onerror = (event) => {
        console.error('Speech recognition error:', event.error);
      };

      this.recognition.onend = () => {
        console.log('Speech recognition ended.');
        this.isSpeaking = false;
        this.isListening = false;
      };

      this.recognition.start();
    },
    prepareNextPrompt() {
      if (this.currentPromptIndex < this.prompts.length) {
        this.userInput = '';
        this.words = this.prompts[this.currentPromptIndex].split(' ');
        this.currentWordIndex = 0;
      }
    },
    startTypingEffect() {
      this.typingInterval = setInterval(() => {
        if (this.currentWordIndex < this.words.length) {
          this.userInput += this.words[this.currentWordIndex] + ' ';
          this.currentWordIndex++;
        } else {
          clearInterval(this.typingInterval);
          setTimeout(() => {
            this.currentPromptIndex++;
            if (this.currentPromptIndex < this.prompts.length) {
              this.prepareNextPrompt();
              this.startTypingEffect();
            }
          }, 1000);
        }
      }, 150);
    },
    StripTypingEffect() {
      this.stripTypingInterval = setInterval(() => {
        if (this.typingIndex < this.predefinedPrompt.length) {
          this.stripInput += this.predefinedPrompt[this.typingIndex];
          this.typingIndex++;
        } else {
          clearInterval(this.stripTypingInterval);
        }
      }, 150);
    },
    clearPropmpts() {
      clearInterval(this.typingInterval);
      this.words = [];
      this.userInput = '';
    }

  },
  mounted() {
    this.StripTypingEffect();
    this.prompts = getAiPrompts().map(p => p.prompt);
    eventBus.$on('hidePrompts', (response) => {
      if (response) {
        this.clearPropmpts();
        if (document.getElementById('MessageContainer')) {
          document.getElementById('MessageContainer').focus();
        }
      }
    });

  },
  updated() {
    if (this.showChatData && this.isGradient) {
      // setTimeout(() => {
      //   document.querySelectorAll('.ask_ai ._dynamic_text_color').forEach((item) => {
      //     console.log(item, 'item')
      //     item.style.setProperty('color', '#fff', 'important');
      //   });
      //   document.querySelectorAll('.ask_ai ._dynamic_bg_color').forEach((item) => {
      //     item.style.setProperty('background', 'rgba(255,255,255,0.1)', 'important');
      //     item.style.setProperty('box-shadow', 'none', 'important');
      //   });
      // }, 1500);
    }
  },
  components: {
    UserQuestion,
    AssistantIcon,
    // MicroPhone,
    AiFullFillMentText,
    TvmPreLoader,
    AiHoursModal,
    DealerWorkingHours,
    MicrophoneIcon,
    AssistantWithSpark

  },
  watch: {
    showChatData(newValue) {
      if (newValue) {
        this.startTypingEffect();
        this.prepareNextPrompt();
        // this.inputRef.focus();
      }
    },

  },
};
</script>

<style scoped>
.overlay_section {
  position: fixed;
  height: 100%;
  z-index: 9;
  width: 100%;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.7);
}

#MessageBox {
  resize: none;
}

.gap-lg-2 {
  gap: 20px;
}

.gap-lg-1 {
  gap: 10px;
}


.ask_ai input::placeholder {
  font-size: 1rem;
  font-weight: 500;
}

.ask_ai input {
  height: 4rem;
  font-size: 16px;
  color: #000;
}

.border_horizontal {
  width: 1px;
  height: 2.5rem;
  background: #000;
  display: block;
}

.expandable-content {
  flex-grow: 1;
  /* height: 76vh; */
  background: #f9f9f9;
  border-radius: 0 0;
  display: flex;
  flex-direction: column;
  position: fixed;
  left: 0;
  right: 0;
  height: calc(100vh - 100px);
  z-index: 98;
  max-width: 80%;
}

.classicDesign .conversation_container {
  width: 70%;
  margin: auto;
}

.classicDesign .chat_input_container {
  width: 70%;
  margin: 15px auto;
}


.expand-enter-active,
.expand-leave-active {
  transition: height 0.5s ease, opacity 0.5s ease;
  overflow: hidden;
}

.expand-enter,
.expand-leave-to {
  height: 0;
  opacity: 0;
}

.conversation_container {
  overflow-y: auto;
}

.chat_input_container {
  background: #fff;
  margin-bottom: 10px;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  border-radius: 15px;
  padding: 10px;
}

.custom_box_shadow {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
  z-index: 1;
}

.send_icon {
  height: 40px;
  width: 40px;
  border-radius: 7px;
  font-size: 17px;
}

.send_icon em {
  display: inline;
  color: #fff;
  transform: rotate(270deg);
}

.cursor_pointer {
  cursor: pointer;
}


.close_icon_container {
  right: 15px;
  z-index: 9;
}

.ask_ai #chat__bodyview :deep(.primaryicon-right-arrow) {
  width: 20px;
  height: 43px;
  border-radius: 3px;
  margin: 0;
  padding: 5px !important;
  font-size: 12px;
  z-index: 99;
  right: -20px !important;
  position: absolute;
}

.ask_ai #chat__bodyview :deep(.primaryicon-left-arrow) {
  width: 20px;
  height: 43px;
  border-radius: 3px;
  margin: 0;
  padding: 5px;
  font-size: 12px;
  z-index: 99;
  left: -20px !important;
  position: absolute;
}

.ask_ai #chat__bodyview :deep(.v-slick-slider em[disabled=false]) {
  display: none !important;
}


.ask_ai :deep(.v-slick-dots li button:before) {
  font-size: 16px;
}


.ask_ai :deep(p) {
  font-size: 14px;
}

.ask_ai :deep(.shadow-sm) {
  box-shadow: 0 2px 20px 2px rgba(227, 230, 236, 0.6) !important;
}

.service__types__btn h6 {
  font-size: 12px;
}

.ask_ai .strip_input {
  font-weight: bold;
}

@media (min-width: 1920px) and (max-width: 2399px) {
  .ask_ai .strip_input {
    font-size: 26px;
  }

  .ask_ai :deep(p) {
    font-size: 17px;
  }

  .ask_ai .footer_icon {
    font-size: 13px;
    padding: 10px 15px;
  }

  .service__types__btn h6 {
    font-size: 15px;
  }
}

.footer_icon {
  /* border-radius: 8px; */
  background: #eee;
  font-size: 12px;
}

.ask_ai .footer_icon:hover {
  background: #fff;
  transition: all 0.3s ease;
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.ask_ai .footer_icon {
  font-size: 13px;
  padding: 10px 15px;
}

.send_container {
  gap: 25px;
}

.bar-slide-enter-active,
.bar-slide-leave-active {
  transition: transform 0.4s ease;
}

.bar-slide-enter-from,
.bar-slide-leave-to {
  transform: translateY(-100%);
}

.bar-slide-enter-to,
.bar-slide-leave-from {
  transform: translateY(0);
}

/* Window Slide */
.window-slide-enter-active,
.window-slide-leave-active {
  transition: transform 0.5s ease;
}

.window-slide-enter-from,
.window-slide-leave-to {
  transform: translateY(-100%);
}

.window-slide-enter-to,
.window-slide-leave-from {
  transform: translateY(0);
}

/* Input Slide */
.input-slide-enter-active,
.input-slide-leave-active {
  transition: transform 0.3s ease;
}

.input-slide-enter-from,
.input-slide-leave-to {
  transform: translateY(100%);
}

.input-slide-enter-to,
.input-slide-leave-from {
  transform: translateY(0);
}

.primary-close-circle_icon {
  border-radius: 24px;
  border: 0;
  padding: 8px 10px;
  font-size: 10px;
  text-align: center;
  display: inline-block;
}

.arrow_down {
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  border-radius: 10px;
}

.arrow_down em {
  transform: rotate(90deg);
}

.voice-animation {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 10px;
}

.pulse-container {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pulse {
  animation: pulse-animation 2s infinite;
  background-color: #f6f6f6;
}



@keyframes pulse-animation {
  0% {
    box-shadow: 0 0 0 0px rgba(0, 0, 0, 0.2);
  }

  100% {
    box-shadow: 0 0 0 20px rgba(0, 0, 0, 0);
  }
}
</style>
<style>
.custom_box_shadow {
  box-shadow: rgba(149, 157, 165, 0.2) 0px 8px 24px;
}

.ask_ai .svg_icon svg {
  height: auto !important;
}
</style>
